<template>
    <div v-if="typeof selectedApron !== 'undefined'">
        <div class="row selected-apron mb-2">
            <div class="col-6"><span class="detail-name">{{ $t('apronShortlist.status') }}</span></div>
            <div class="col-6 max-width-200"><apron-status :int-status="selectedApron.status"></apron-status></div>
        </div>
        <div class="row selected-apron mb-2">
            <div class="col-6"><span class="detail-name">{{ $t('apronShortlist.sn') }}</span></div>
            <div class="col-6"><span class="detail-value"><b>{{selectedApron.serialNumber}}</b></span></div>
        </div>

        <div class="row selected-apron mb-2">
            <div class="col-6"><span class="detail-name">{{ $t('addEditApron.manufacturer') }}</span></div>
            <div class="col-6"><span class="detail-value">{{selectedApron.model.manufacturer.name}}</span></div>
        </div>

        <div class="row selected-apron mb-2">
            <div class="col-6"><span class="detail-name">{{ $t('addEditApron.model') }}</span></div>
            <div class="col-6"><span class="detail-value">{{selectedApron.model.name}}</span></div>
        </div>

        <div v-if="selectedApron.model.manufacturerID == 1" class="row selected-apron mb-2">
            <div class="col-6"><span class="detail-name">{{ $t('addEditApron.fabricColor') }}</span></div>
            <div class="col-6"><span v-if="selectedApron.fabricColor !== null" class="detail-value">{{selectedApron.fabricColor.name}}</span></div>
        </div>

        <div v-if="selectedApron.model.category != 3 && selectedApron.model.manufacturerID == 1" class="row selected-apron mb-2">
            <div class="col-6"><span class="detail-name">{{ $t('addEditApron.ribbonColor') }}</span></div>
            <div class="col-6"><span v-if="selectedApron.ribbonColor !== null" class="detail-value">{{selectedApron.ribbonColor.name}}</span></div>
        </div>

        <div class="row selected-apron mb-2">
            <div class="col-6"><span class="detail-name">{{ $t('addEditApron.size') }}</span></div>
            <div class="col-6"><span class="detail-value">{{SizeToString(selectedApron.size)}}</span></div>
        </div>

        <div v-if="selectedApron.model.category != 3 && selectedApron.model.manufacturerID == 1" class="row selected-apron mb-2">
            <div class="col-6"><span class="detail-name">{{ $t('apronDetail.sizeAdjustments') }}</span></div>
            <div class="col-6"><span class="detail-value">{{SizeAdjustmentReadable}}</span></div>
        </div>

        <div class="row selected-apron mb-2">
            <div class="col-6"><span class="detail-name">{{ $t('addEditApron.productionDate') }}</span></div>
            <div class="col-6"><span class="detail-value">{{toHTML5date(selectedApron.productionDate)}}</span></div>
        </div>

        <div class="row selected-apron mb-2">
            <div class="col-6"><span class="detail-name">{{ $t('apronShortlist.user') }}</span></div>
            <div class="col-6"><span class="detail-value">{{selectedApron.nameOfUser}}</span></div>
        </div>

        <div class="row selected-apron mb-2">
            <div class="col-6"><span class="detail-name">{{ $t('addEditApron.department') }}</span></div>
            <div class="col-6">
                <span v-if="cptDepartment != null" class="detail-value">
                    {{cptDepartment.name}}
                </span>
            </div>
        </div>

        <div v-if="selectedApron.model.manufacturerID == 1" class="row selected-apron mb-2">
            <div class="col-6"><span class="detail-name">{{ $t('configurator.material') }}</span></div>
            <div class="col-6"><span class="detail-value">{{MaterialToString(selectedApron.internalMaterial)}}</span></div>
        </div>

        <div class="row selected-apron mb-2">
            <div class="col-6"><span class="detail-name">{{ $t('apronDetail.leadEquivalence') }}</span></div>
            <div class="col-6"><span class="detail-value">{{cptLeadEq}}</span></div>
        </div>

        <div class="row selected-apron mb-2">
            <div class="col-6"><span class="detail-name">{{ $t('addEditApron.monogram') }}</span></div>
            <div class="col-6"><span v-if="selectedApron.embroidery != ', '" class="detail-value">{{selectedApron.embroidery}}</span></div>
        </div>

    </div>
</template>

<script>
    //import Bus from '@/Bus.js';
    import * as general from '@/scripts/General.js';
    import ApronStatus from '@/private/components/UI-elements/ApronStatus.vue';

    export default {
        name: 'ApronDetail',
        props: {
            selectedApron: Object

        },
        components: {
            ApronStatus
        },
        data: function () {

            return {
            }

        },
        mounted: function () {
            //Get Reports
            //this.$store.dispatch('GET_lstDiscardedAprons')

        },
        methods: {
            SizeToString: general.SizeToString,
            toHTML5date: general.toHTML5date,
			MaterialToString: general.MaterialToString
        },
        computed: {
            SizeAdjustmentReadable: function () {

				if (this.selectedApron.sizeAdjustments == null || this.selectedApron.sizeAdjustments.length == 0) {
                    return 'None known.'
				}

                var returnValue = ''
                for (var i = 0; i < this.selectedApron.sizeAdjustments.length; i++) {
                    const adj = this.selectedApron.sizeAdjustments[i]

					if (i > 0) {
						returnValue += ', '
					}

                    if (adj.adjustmentType == 1) {
						returnValue += this.$t('configurator.lengthAdjustment') + ': '
                    } else if (adj.adjustmentType == 2) {
						returnValue += this.$t('configurator.extraOverlap') + ': '
                    }
					returnValue += adj.parameter1 + 'cm'
                }

                return returnValue
            },
            cptLeadEq: function () {
                var returnValue = ''


                returnValue += 'Front: ' + general.PbEqToString(this.selectedApron.pbEqFront)

                //Only appliccable for all round protection
				if (this.selectedApron.model.category == 1) {
					returnValue += ', Back: ' + general.PbEqToString(this.selectedApron.pbEqBack)
				}

                return returnValue;
            },
            cptDepartment: function () {
                var myDept = this.$store.state.lstDepartments.filter(x => x.departmentID == this.selectedApron.departmentID)

				if (myDept.length == 1) {
                    return myDept[0];
                }

                return null
            },
        }
    }
</script>
